import objectFitImages from 'object-fit-images';
objectFitImages();

import initRellax from './modules/rellax';
initRellax();

import initAnimation from './modules/animation';
initAnimation();

const arrowStyleButtons = document.querySelectorAll('.wp-block-button[class *= is-style-arrow-]');
arrowStyleButtons.forEach(node => {
    const linkNode = node.querySelector('.wp-block-button__link');
    if (linkNode) {
        if (node.className.indexOf('is-style-arrow-left') > -1) {
            linkNode.innerHTML = '<svg class="wp-block-button__arrow wp-block-button__arrow--left" viewBox="0 0 10 19"><path style="stroke-width:0px;" d="m9.69,17.02l-6.96-7.51L9.65,1.97c.43-.47.41-1.22-.06-1.66-.46-.44-1.19-.42-1.63.06L.31,8.72c-.41.45-.41,1.15,0,1.6l7.7,8.31c.44.47,1.17.49,1.63.05.46-.44.48-1.19.05-1.66Z"></svg>' + linkNode.innerHTML;
        } else if (node.className.indexOf('is-style-arrow-right') > -1) {
            linkNode.innerHTML += '<svg class="wp-block-button__arrow wp-block-button__arrow--right" viewBox="0 0 10 19"><path style="stroke-width:0px;" d="m.31,1.98l6.96,7.51L.35,17.03c-.43.47-.41,1.22.06,1.66.46.44,1.19.42,1.63-.06l7.66-8.35c.41-.45.41-1.15,0-1.6L1.99.37C1.55-.1.82-.12.36.32c-.46.44-.48,1.19-.05,1.66Z"></svg>';
        }
    }
});

document.querySelectorAll('.we-block-random-text').forEach(container => {
    const texts = container.children;

    if (texts.length > 0) {
        const targetCount = Math.floor( Math.random() * texts.length );
        for (let i = 0; i < texts.length; i++) {
            if (i === targetCount) {
                texts[i].classList.add('active');
                break;
            }
        }
    }
});

document.querySelectorAll('.wbc-vprofile__content--more').forEach(container => {
    const button = document.createElement('button');
    button.className = 'wbc-vprofile__more-button';
    button.appendChild(document.createTextNode('もっと見る'));
    button.addEventListener('click', e => {
        if (container.classList.contains('is-show')) {
            container.classList.remove('is-show');
            e.target.textContent = 'もっと見る';
        } else {
            container.classList.add('is-show');
            e.target.textContent = '表示を短くする';
        }

    });
    container.appendChild(button);
});
